import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { USER_TYPE } from "../../Enums/User.enum.mjs";
import BCLinkReactRouterDom from "../../components/BCLinkReactRouterDom.js";
import BCTable from "../../components/BCTable.js";
import { list } from "./service.js";

export default function UsersListAgents() {
  const theme = useTheme();
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState(1);
  const [sortField, setSortField] = useState("name");
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);

  const listUsers = useCallback(async () => {
    setLoading(true);
    const result = await list({
      limit: pageSize,
      page: currentPage,
      search: search,
      sort: sortOrder,
      sortField: sortField,
      type: USER_TYPE.AGENT,
    });
    console.log("AAAA", result);
    setUsers(result.result);
    setTotal(result.count);
    setLoading(false);
  }, [pageSize, currentPage, search, sortOrder, sortField]);

  useEffect(() => {
    listUsers();
  }, [listUsers]);

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      align: "center",
      sorter: true,
      width: "20%",
    },
    {
      title: t("Institution"),
      dataIndex: "implementer",
      align: "center",
      sorter: true,
      width: "20%",
      render: (text, record) => (
        <span key={record.implementer}>
          {record.implementer ? record.implementer.name : ""}
        </span>
      ),
    },
    {
      title: t("Localazation"),
      dataIndex: "localazation",
      align: "center",
      sorter: true,
      width: "20%",
      render: (text, record) => (
        <span>
          {record.city} - {record.state}
        </span>
      ),
    },
    {
      title: t("Number_of_Farms"),
      dataIndex: "x",
      align: "center",
      sorter: true,
      width: "20%",
      render: (text, record) => <span>Sem o Dado no Momento</span>,
    },
    {
      title: t("Last_Acess"),
      dataIndex: "last_acess",
      align: "center",
      sorter: true,
      width: "20%",
      render: (text, record) => (
        <span key={record.last_acess}>
          {record.last_acess
            ? new Date(record.last_acess).toLocaleDateString()
            : t("Never_accessed")}
        </span>
      ),
    },
  ];

  return (
    <div>
      <BCTable
        data={users}
        total={total}
        pageSize={pageSize}
        currentPage={currentPage}
        placeholderSearch={`${t("Search")} ${t("USERS_3")}`}
        setSearch={setSearch}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
        setSortField={setSortField}
        setSortOrder={setSortOrder}
        loading={loading}
        columns={columns}
        actionsColumn={[]}
        showCreateButton={false}
        showSizeChanger={false}
        children={
          <BCLinkReactRouterDom
            text={t("REGISTER_NEW_USER")}
            to={"/users/agent/create"}
          />
        }
      />
    </div>
  );
}
